import React, { Component } from 'react'
import { BrowserRouter as Router, Redirect } from 'react-router-dom'

import { ApiManagement, SideNav } from './'
import { AdminRoute } from './../../'
import PageWithSidebar from 'components/PageWithSidebar'

import RegisteredAccounts from 'pages/Admin/Accounts/RegisteredAccounts'
import AdminAccounts from 'pages/Admin/Accounts/AdminAccounts'
import PendingInvites from 'pages/Admin/Accounts/PendingInvites'
import PartnerInvite from 'pages/Admin/Accounts/PartnerInvite'
import { store } from 'services/state.js'
// import PendingRequests from 'pages/Admin/Accounts/PendingRequests'

function RedirectToApiManagement () {
  return <Redirect to='/admin/apis' />
}

function RedirectToUserAccounts () {
  return <Redirect to='/admin/accounts' />
}

export class Admin extends Component {
  render () {
    return (
      <Router>
        <PageWithSidebar sidebarContent={<SideNav />}>
          <>
            <AdminRoute exact from='/admin' component={RedirectToApiManagement} />
            {store.userType === 'SUPER_ADMIN' && <AdminRoute path='/admin/apis' component={ApiManagement} />}
            {store.userType === 'PARTNER' && <AdminRoute path='/admin/apis' component={RedirectToUserAccounts} />}
            <AdminRoute exact path='/admin/accounts' component={RegisteredAccounts} />
            <AdminRoute exact path='/admin/accounts/admins' component={AdminAccounts} />
            <AdminRoute exact path='/admin/accounts/invites' component={PendingInvites} />
            <AdminRoute exact path='/admin/accounts/invitepartner' component={PartnerInvite} />
            {/* <AdminRoute exact path='/admin/accounts/requests' component={PendingRequests} /> */}
          </>
        </PageWithSidebar>
      </Router>
    )
  }
}
